import 'stylesheets/pages/users/sign_up/scouters/style';

import Tooltip from 'modules/Tooltip';

new Tooltip();
